/* Mesozoic menu: the Shop and Collections tabs open their OWN detached panel on computer (Launch Sale and Info & Contact are ITA panels, assets/ita-menu-panels.js).
   Opens on pointer, focus or tap. Closes only after the pointer has left the tab, its panel AND the strip between them for ~350 ms (the strip is
   also covered by an invisible bridge on the panel), so you can travel from the tab down into the panel and click. Esc / clicking the dimmed page close it.
   Phone uses the drawer (tabs there are handled at the bottom). */
(function () {
  var sc = document.getElementById("mzmScrim"), hdr = document.querySelector(".ita-hdr .hdr");
  var panels = {}; [].forEach.call(document.querySelectorAll(".mzm-panel[data-p]"), function (p) { panels[p.dataset.p] = p; });
  var trig = {}; [].forEach.call(document.querySelectorAll("[data-mzm]"), function (d) { trig[d.dataset.mzm] = d; });
  if (!sc || !hdr || !Object.keys(panels).length) return;
  var cur = null, timer = null, moving = false, lastX = 0, lastY = 0;
  var wide = function () { return window.innerWidth > 1000; };
  var hover = window.matchMedia && matchMedia("(hover: hover)");
  function pos() { var r = hdr.getBoundingClientRect(); document.documentElement.style.setProperty("--mzm-top", Math.max(0, Math.round(r.bottom)) + "px"); }
  function setActive(p, k) {
    var rows = [].slice.call(p.querySelectorAll(".mzm-r[data-k]")), sl = [].slice.call(p.querySelectorAll(".mzm-fs[data-k]"));
    rows.forEach(function (r) { r.classList.toggle("is-on", r.dataset.k === String(k)); }); sl.forEach(function (s) { s.classList.toggle("on", s.dataset.k === String(k)); });
  }
  Object.keys(panels).forEach(function (n) {
    var p = panels[n];
    [].forEach.call(p.querySelectorAll(".mzm-r[data-k]"), function (r) { r.addEventListener("mouseenter", function () { setActive(p, r.dataset.k); }); r.addEventListener("focus", function () { setActive(p, r.dataset.k); }); });
    setActive(p, 0);
    p.addEventListener("mouseenter", function () { cancel(); });
    p.addEventListener("mouseleave", function () { later(); });
    p.addEventListener("focusin", function () { cancel(); });
  });
  function show(n) {
    if (!wide() || !panels[n]) return; cancel(); pos();
    if (cur && cur !== n) { var o = panels[cur]; o.classList.remove("on"); o.hidden = true; }
    var p = panels[n]; if (cur !== n) { setActive(p, 0); p.hidden = false; requestAnimationFrame(function () { p.classList.add("on"); }); }
    cur = n; sc.hidden = false; requestAnimationFrame(function () { sc.classList.add("on"); });
    Object.keys(trig).forEach(function (k) { var a = trig[k].firstElementChild; if (a) a.setAttribute("aria-expanded", k === n ? "true" : "false"); });
  }
  function hide() {
    cancel(); if (!cur) return; var p = panels[cur]; cur = null; p.classList.remove("on"); sc.classList.remove("on");
    Object.keys(trig).forEach(function (k) { var a = trig[k].firstElementChild; if (a) a.setAttribute("aria-expanded", "false"); });
    setTimeout(function () { if (!cur) { p.hidden = true; sc.hidden = true; } }, 210);
  }
  function cancel() { clearTimeout(timer); timer = null; }
  function later() { clearTimeout(timer); timer = setTimeout(hide, 350); }
  /* the strip between the open tab and its panel counts as "still inside": a rectangle from the tab down to the panel, as wide as both together */
  function inSafe(x, y) {
    if (!cur) return false; var p = panels[cur], t = trig[cur]; if (!p || !t) return false;
    var a = t.getBoundingClientRect(), b = p.getBoundingClientRect(), pad = 8;
    if (x >= a.left - pad && x <= a.right + pad && y >= a.top - pad && y <= a.bottom + pad) return true;
    if (x >= b.left - pad && x <= b.right + pad && y >= b.top - 30 && y <= b.bottom + pad) return true;
    var L = Math.min(a.left, b.left) , R = Math.max(a.right, b.right); /* the strip */
    if (x >= Math.max(a.left - 60, L) && x <= Math.min(a.right + 60, R) && y >= a.bottom && y <= b.top) return true;
    return false;
  }
  document.addEventListener("mousemove", function (e) {
    lastX = e.clientX; lastY = e.clientY; if (moving || !cur) return; moving = true;
    requestAnimationFrame(function () { moving = false; if (!cur) return; if (inSafe(lastX, lastY)) cancel(); else if (!timer) later(); });
  }, { passive: true });
  Object.keys(trig).forEach(function (k) {
    var d = trig[k], a = d.firstElementChild;
    d.addEventListener("mouseenter", function () { show(k); });
    d.addEventListener("mouseleave", function () { later(); });
    if (a) {
      a.addEventListener("focus", function () { show(k); });
      a.setAttribute("aria-haspopup", "true"); a.setAttribute("aria-controls", "mzm-" + k); a.setAttribute("aria-expanded", "false");
      /* touch / no hover (a tablet in landscape): the first tap opens the panel, a second tap follows the link */
      a.addEventListener("click", function (e) { if (hover && !hover.matches && wide() && cur !== k) { e.preventDefault(); show(k); } });
    }
  });
  /* owner 2026-11-02: moving from Shop / Collections onto another top item (Home, Launch Sale, Info & Contact = ITA panels) shuts ours AT ONCE,
     no 350 ms wait and no fade, so it never lingers behind ITA's panel */
  function hideNow() {
    if (!cur) return; var p = panels[cur]; hide(); p.style.transition = "none"; p.hidden = true; sc.classList.remove("on"); sc.hidden = true;
    requestAnimationFrame(function () { p.style.transition = ""; });
  }
  [].forEach.call(document.querySelectorAll("#nav > a, #nav > .dd:not([data-mzm])"), function (x) {
    x.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") hideNow(); });
    x.addEventListener("focusin", hideNow);
  });
  sc.addEventListener("click", hide);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") hide(); });
  document.addEventListener("focusin", function (e) { if (cur && !panels[cur].contains(e.target) && !(trig[cur] && trig[cur].contains(e.target))) later(); });
  addEventListener("resize", function () { if (!wide()) hide(); });
  addEventListener("scroll", function () { if (cur) pos(); }, { passive: true });
})();
/* Mesozoic menu: the computer panels run on ITA's own assets/ita-menu-panels.js. This file only copies the promo code and switches the phone drawer tabs. */
/* promo banner: tap to copy the code. Phone drawer: tabs. */
(function () {
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-mzm-copy]"); if (b) {
      var c = b.getAttribute("data-mzm-copy"), o = b.getAttribute("data-label") || b.textContent; b.setAttribute("data-label", o);
      var done = function () { b.textContent = b.getAttribute("data-done") || "Copied"; b.classList.add("done"); setTimeout(function () { b.textContent = o; b.classList.remove("done"); }, 1600); };
      try { navigator.clipboard.writeText(c).then(done, done); } catch (x) { done(); }
      return;
    }
    var t = e.target.closest && e.target.closest("[data-mzm-tab]"); if (!t) return; var d = t.closest(".mzm-d"); if (!d) return;
    [].forEach.call(d.querySelectorAll("[data-mzm-tab]"), function (x) { x.setAttribute("aria-selected", x === t); x.classList.toggle("on", x === t); });
    [].forEach.call(d.querySelectorAll("[data-mzm-pane]"), function (p) { p.hidden = p.getAttribute("data-mzm-pane") !== t.getAttribute("data-mzm-tab"); });
  });
})();
